// modifer: styles/jss/nextjs-material-kit-pro/pages/sectionsSections/featuresStyle
import { section, container, title, description } from 'styles/jss/original/base';

const styles = {
  section,
  container,
  title: {
    ...title,
    textAlign: 'center',
    padding: '20px 0'
  },
  description: {
    ...description,
    textAlign: 'center',
    padding: '20px 0 30px',
    whiteSpace: 'pre-wrap',
    '@media (max-width: 576px)': {
      padding: '20px 0'
    },
    '@media (max-width: 411px)': {
      whiteSpace: 'normal'
    }
  },
  textCenter: {
    textAlign: 'center'
  },
  button: {
    marginBottom: '30px'
  }
};

export default styles;
